export interface ApiCheckSensitiveWordRequest {
    tech_desc: string;
}

export type ApiCheckSensitiveWordResponse = {
    out: string;
    error_code: number;
};

export const CheckSensitiveWord = Symbol('CheckSensitiveWord');

export interface CheckSensitiveWord {
    checkSensitiveWord(data: ApiCheckSensitiveWordRequest): Promise<ApiCheckSensitiveWordResponse>;
}

